import { styled } from '@mui/material'

export const SMoreBtn = styled('button')`
    background-color: transparent;
    border: none;
    cursor: pointer;
    margin-left: 8px;
    color: #54687d;
`
